module.exports = __webpack_public_path__ + "img/paypal-success.1b1056fd.png";